import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import querystring from "query-string";
import { getConfig, isUrlWhitelisted, REGISTER_SUCCESS } from "@jti/fe-common";
import ROUTES_PATHS from "../constants/routes";
import { useAemModel } from "../contexts/AemModelContext";
export const useProfileRedirect = () => {
    const { loyaltyCardSuccessPage } = useAemModel();
    const history = useHistory();
    const pushToSuccessfullRegistration = (searchQuery, isDeviceRegistrationMandatory) => {
        const { returnUrl, s: deviceSerial } = querystring.parse(searchQuery || "");
        const { REDIRECT_AFTER_LOGIN_URL, REDIRECT_TO_DEVICE_REGISTRATION_ON_PROFILE, whitelistedDomains } = getConfig();
        if (typeof returnUrl === "string" && returnUrl !== "" && isUrlWhitelisted(returnUrl, whitelistedDomains)) {
            window.location.href = returnUrl;
        }
        else if (typeof deviceSerial === "string" && deviceSerial !== "" && !isDeviceRegistrationMandatory) {
            window.location.href = `${REDIRECT_TO_DEVICE_REGISTRATION_ON_PROFILE}?s=${deviceSerial}`;
        }
        else {
            window.location.href = `${REDIRECT_AFTER_LOGIN_URL}?${REGISTER_SUCCESS}`;
        }
    };
    const pushToSuccessfullOfflineRegistration = ({ firstname, lastname, dob, userId, email, }) => {
        const targetRoute = (loyaltyCardSuccessPage === null || loyaltyCardSuccessPage === void 0 ? void 0 : loyaltyCardSuccessPage.isLoyaltyCardSuccessPageEnabled)
            ? ROUTES_PATHS.offlineRegistrationSuccessWithClubCard
            : ROUTES_PATHS.offlineRegistrationSuccess;
        history.replace(`${targetRoute}?firstname=${firstname}&lastname=${lastname}&dob=${dob}&userId=${userId}&email=${email}`);
    };
    return { pushToSuccessfullRegistration, pushToSuccessfullOfflineRegistration };
};
export const useProfileRedirectWithDeviceCode = () => {
    const pushToDeviceRegistration = useCallback((code) => {
        window.location.href = `${getConfig().REDIRECT_TO_DEVICE_REGISTRATION_ON_PROFILE}?s=${code}`;
    }, []);
    return { pushToDeviceRegistration };
};
